import { Page } from '@/lib/pagination'
import { IPagination } from '@bookips/solvook-shared/interfaces'
import { useLocalObservable } from 'mobx-react-lite'
import { useRef } from 'react'
import { ExtraResource } from '../../factories/ExtrasFactory'

import { ProductDTO, ProductVariantDTO } from '@bookips/solvook-api-shared'

export type ProductSourceType = 'textbook' | 'workbook' | 'handout'

export interface FilterListType {
	id: number
	title: string
	list: string[]
	category: 'unit' | 'etc'
}
export interface Product extends ProductDTO {}

export interface ProductVariant extends ProductVariantDTO {}
export interface HandoutPricePolicyOption {
	label: string
	value: string
	max_usage: number
}

export interface ProductVariantOption extends ProductVariantDTO {}

export interface ProductPriceOptions {
	lite: ProductVariantOption
	basic: ProductVariantOption
	pro: ProductVariantOption
}

export interface ProductActiveOption {
	option: ProductVariantOption
	remain_slot: number
	period: string
}

export interface Products {
	pagination: IPagination
	products: Product[]
}

export interface BasedLicenseType {
	id: number
	title: string
	thumbnail: string
}

export interface ProductOld {
	id: number
	uid?: string

	slug?: string

	source_type: ProductSourceType | string | number
	source_id: number

	title: string
	publisher: string //저작권자ㅊ
	author: string
	price: number

	variants?: ProductVariantOption[]

	priceOptions: ProductPriceOptions
	image: string

	created_at: string | Date
	updated_at: string | Date

	// active_option?: ProductActiveOption
	lesson?: number
	revenue?: number
	view?: number
	isShow?: boolean
	isDeleted?: boolean
	isPublic?: boolean

	questionNumber?: number //문항수
	category?: number | string //자료유형
	subject?: string //과목
	curriculum?: number //교육과정
	grade?: number //학년
	unit?: string //과목

	basedLicense?: BasedLicenseType[] //출처교재
	description?: string //설명
	thumbnails?: string[] //첨부이미지
	published_at?: string | Date //출간년도
	writer?: string //대표저자

	extraResources?: ExtraResource[] //추가구매가능한 상품
}

export interface ProductModelProps {
	products?: Product[]
	product?: Product
	filters?: FilterListType[]
	pagination?: ReturnType<typeof Page>
}

export const ProductModel = (props: ProductModelProps) => {
	return {
		filters: props.filters || ([] as FilterListType[]),
		products: props.products || ([] as Product[]),
		product: props.product || ({} as Product),
		pagination: Page({}),

		updateProducts(products: Product[]) {
			this.products = products
		},
		updateProduct(product: Product) {
			this.products = this.products.map((item) => {
				if (product.id === item.id) {
					return {
						...item,
						...product,
					}
				}
				return item
			})

			this.product = product
		},

		addProducts(products: Products) {
			if (products.pagination && products.products) {
				const { total, limit, offset } = products.pagination

				if (total / (offset + limit) > 1) {
					this.pagination = Page(products.pagination)
				} else {
					this.pagination = Page({ ...products.pagination, offset: total })
				}

				const newProduct: Product[] = products.products
					.filter((task) => !!task?.id)
					.map((x) => x as Product)

				this.products = [...this.products, ...newProduct]
			}
		},

		update(products: Products) {
			this.pagination = Page(products?.pagination || {})
			this.products = (products?.products as Product[]) || []
		},

		get last(): Product {
			if (this.products.length > 0) {
				return this.products[this.products.length - 1]
			} else {
				return null
			}
		},
	}
}

export const useProductModelStore = (props: ProductModelProps) => {
	return useLocalObservable(() => ProductModel(props))
}

export const createProductStore = (props: Partial<ProductModelProps> = {}) => {
	const stores = useRef({
		products: useProductModelStore(props),
	})

	return stores.current
}

export type ProductStoreType = ReturnType<typeof createProductStore>
